// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"x2-z","dimensionLabel":"y2-z","styleChooserControlWrapper":"z2-z","styleChooserControl":"A2-z","disabled":"B2-z","giftCard":"C2-z","styleChooserText":"D2-z"};